import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  policy: null,
  terms: null,
  loading: false,
  error: null,
};

const policyTermsSlice = createSlice({
  name: "policyTerms",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setPolicy(state, action) {
      state.policy = action.payload || null;
    },
    clearPolicy(state) {
      state.policy = null;
    },
    setTerms(state, action) {
      state.terms = action.payload || null;
    },
    clearTerms(state) {
      state.terms = null;
    },
    setError(state, action) {
      state.error = action.payload || null;
    },
  },
});

export const { setLoading, setPolicy, clearPolicy, setTerms, clearTerms, setError } = policyTermsSlice.actions;

export default policyTermsSlice.reducer;


